/**
 * @author jakubbujakowski
 * @since 2022-3-2
 *
 * IMPORTANT!
 * Smartlook is injected and initialized via GTM.
 * This component will only work on environemnts where GTM has been configured.
 */
import React, { useEffect } from "react";
import { Record } from "immutable";

import { IS_BROWSER } from "@config/consts";

import { IUser } from "@typings/user";

import { useAuth } from "@hooks/useAuth";

interface Props {
  urlWhitelist?: string[]; // when passed, only allow recording on these routes
}

const SmartlookClient = (props: Props): null => {
  const { user } = useAuth();

  const disableSmartlookEffectDeps = IS_BROWSER ? [window.location.href] : [];

  const isUrlSupported = () =>
    props.urlWhitelist === undefined ||
    props.urlWhitelist?.some(url => window.location.href.includes(url));

  const handleIdentify = (user: Record<IUser>) => {
    (window as any)?.smartlook?.("identify", user.get("uuid"), {
      name: `${user.get("firstName")} ${user.get("lastName")}`,
      email: user.get("email"),
    });
  };

  const handleAnonymize = () => {
    (window as any)?.smartlook?.("anonymize");
  };

  const handleDisable = () => {
    (window as any)?.smartlook?.("disable");
  };

  useEffect(() => {
    if (!user) {
      handleAnonymize();
      return;
    }

    handleIdentify(user);
  }, [user]);

  useEffect(() => {
    if (!isUrlSupported()) {
      handleDisable();
    }
  }, [disableSmartlookEffectDeps]);

  return null;
};

export { SmartlookClient };
